"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapStateToProps = exports.mapDispatchToProps = void 0;
var PlaceAction_1 = require("@/pages/place/actions/PlaceAction");
var ResultAction_1 = require("@/pages/search/actions/sfilter/ResultAction");
var VideoAction_1 = require("@/pages/detail/actions/VideoAction");
exports.mapDispatchToProps = function (dispatch) { return ({
    showPop: function (popState) { return dispatch(PlaceAction_1.default.showPop(popState)); },
    setMapType: function (mapType) { return dispatch(PlaceAction_1.default.setMapType(mapType)); },
    fullsize: function (index) { return dispatch(PlaceAction_1.default.fullsize(index)); },
    toggleNeighbourhoodGroupActive: function (index) {
        return dispatch(PlaceAction_1.default.toggleNeighbourhoodGroupActive(index));
    },
    setNearbyType: function (type) {
        return dispatch(PlaceAction_1.default.setNearbyType(type));
    },
    onSimilarEnquireClicked: function (item) { return dispatch(ResultAction_1.default.onEnquireClicked(item)); },
    onSimilarMouseDown: function (item) { return dispatch(ResultAction_1.default.onMouseDown(item)); },
    onSimilarMouseUp: function (item) { return dispatch(ResultAction_1.default.onMouseUp(item)); },
    toggleNeighbourMobileFilter: function () { return dispatch(PlaceAction_1.default.toggleNeighbourMobileFilter()); },
    changeDistrictInfo: function (i) { return dispatch(PlaceAction_1.default.changeDistrictInfo(i)); },
    onEnquireClicked: function () { return dispatch(PlaceAction_1.default.onEnquireClicked()); },
    onSubitemClick: function (i, point) { return dispatch(PlaceAction_1.default.onSubitemClick(i, point)); },
    addPlaceClick: function () { return dispatch(PlaceAction_1.default.addPlaceClick()); },
    similarNext: function () { return dispatch(PlaceAction_1.default.similarNext()); },
    similarPrev: function () { return dispatch(PlaceAction_1.default.similarPrev()); },
    onGalleryItemClicked: function (src) { return dispatch(PlaceAction_1.default.onGalleryItemClicked(src)); },
    followClicked: function () { return dispatch(PlaceAction_1.default.followClicked()); },
    unfollowClicked: function () { return dispatch(PlaceAction_1.default.unfollowClicked()); },
    setGalleryIndex: function (index) { return dispatch(PlaceAction_1.default.setGalleryIndex(index)); },
    setTopGalleryScroll: function (index) { return dispatch(PlaceAction_1.default.setTopGalleryScroll(index)); },
    onGalleryMapClicked: function () { return dispatch(PlaceAction_1.default.onGalleryMapClicked()); },
    onFollowPopupCloseClick: function () { return dispatch(PlaceAction_1.default.onFollowPopupCloseClick()); },
    forceFactsViewMore: function () { return dispatch(PlaceAction_1.default.forceFactsViewMore()); },
    forceFeaturesViewMore: function () { return dispatch(PlaceAction_1.default.forceFeaturesViewMore()); },
    forceAboutViewMore: function () { return dispatch(PlaceAction_1.default.forceAboutViewMore()); },
    onCurrentTimeChanged: function (currentTime) {
        return dispatch(VideoAction_1.default.onCurrentTimeChanged(currentTime));
    },
    onTotalTimeChanged: function (totalTime) {
        return dispatch(VideoAction_1.default.onTotalTimeChanged(totalTime));
    },
    onEnded: function () { return dispatch(VideoAction_1.default.onEnded()); },
    onChangeStart: function () { return dispatch(VideoAction_1.default.onChangeStart()); },
    onChange: function (newCurrent) { return dispatch(VideoAction_1.default.onChange(newCurrent)); },
    onChangeEnd: function (newCurrent) { return dispatch(VideoAction_1.default.onChangeEnd(newCurrent)); },
    onPlayToggle: function () { return dispatch(VideoAction_1.default.onPlayToggle()); },
    onMutedToggle: function () { return dispatch(VideoAction_1.default.onMutedToggle()); },
    onPlaylistClick: function (video) { return dispatch(VideoAction_1.default.onPlaylistClick(video)); },
    onPlayerClick: function () { return dispatch(VideoAction_1.default.onPlayerClick()); },
    setVideoPopupActive: function (isActive) { return dispatch(PlaceAction_1.default.setVideoPopupActive(isActive)); },
    onItemClicked: function (item) { return dispatch(ResultAction_1.default.onItemClicked(item)); },
    onSortUpdateCompleted: function () { return dispatch(PlaceAction_1.default.onSortUpdateCompleted()); },
}); };
exports.mapStateToProps = function (state) {
    return (__assign(__assign({}, state.place), { googleApikey: state.layout.googleApi, symbol: state.layout.currencies.options
            .filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol, currencyCode: state.layout.currencies.options
            .filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].code2, lang: state.layout.language.languages
            .filter(function (it) { return it.id === state.layout.language.current; })[0].code1, isGuest: state.user.id ? false : true, shareT: state.translate }));
};
